import { Icon } from "semantic-ui-react";

import "modules/CommunicationTemplates/components/CommunicationTemplatesTable/components/DuplicateTemplateButton/DuplicateTemplateButton.scss";

type DuplicateTemplateButtonProps = {
  onClick: () => void;
};

export const DuplicateTemplateButton = ({ onClick }: DuplicateTemplateButtonProps) => (
  <div
    className="duplicate-template-button"
    onClick={e => {
      e.stopPropagation();
      onClick();
    }}
  >
    <div>
      <Icon className="copy duplicate-template-button-icon" />
    </div>
  </div>
);
